import initPreloader from './modules/preolader';
import initNavigation from './modules/navigation';
import initTeam from './modules/team';
import initGallery from './modules/gallery';
import VideoPopup from './modules/video-modal';

import '../scss/styles.scss';

document.addEventListener('DOMContentLoaded', () => {
  initPreloader();
  initNavigation();
  initTeam();
  initGallery();
  VideoPopup();
});
